export enum EExploreTabs {
  Featured = 'Featured',
  Following = 'Following',
  Everyone = 'Everyone',
  Channels = 'Channels',
}
